// extracted by mini-css-extract-plugin
export var typingIndicator = "_ng-0";